/*------------------------------------------------------------------------------
Content of this file was generated with the following code added in
SecurityKeyDefinition.java:

  public static void main(String[] args) {
    Arrays.stream(SecurityKeyDefinition.values())
      .map(Enum::name)
      .sorted()
      .forEach(s -> System.out.printf("export const %s = \"%s\";%n", s, s));
  }

------------------------------------------------------------------------------*/
export const ALERTES_AU_QUOTIDIEN = "ALERTES_AU_QUOTIDIEN";
export const ANNUAIRE_VISU = "ANNUAIRE_VISU";
export const CAHIER_RAPPEL_TOKEN_MODIF = "CAHIER_RAPPEL_TOKEN_MODIF";
export const CAHIER_RAPPEL_VISU = "CAHIER_RAPPEL_VISU";
export const CAISSE_CSI_FILE_DOWNLOAD = "CAISSE_CSI_FILE_DOWNLOAD";
export const CAISSE_CSI_FILE_EXPORT = "CAISSE_CSI_FILE_EXPORT";
export const CAISSE_CSI_FILE_UPLOAD = "CAISSE_CSI_FILE_UPLOAD";
export const CAISSE_PI_FILE_DOWNLOAD = "CAISSE_PI_FILE_DOWNLOAD";
export const CAISSE_PI_FILE_EXPORT = "CAISSE_PI_FILE_EXPORT";
export const CAISSE_PI_FILE_UPLOAD = "CAISSE_PI_FILE_UPLOAD";
export const CEGEDIM_THIRD_PARTY_SOFT_WRITE = "CEGEDIM_THIRD_PARTY_SOFT_WRITE";
export const CEGID_THIRD_PARTY_SOFT_TRANSMIT_TO_CEGID =
  "CEGID_THIRD_PARTY_SOFT_TRANSMIT_TO_CEGID";
export const CEGID_THIRD_PARTY_SOFT_WRITE = "CEGID_THIRD_PARTY_SOFT_WRITE";
export const COMPTA_ACOMPTE_MODIF = "COMPTA_ACOMPTE_MODIF";
export const COMPTA_ACOMPTE_SUPPR = "COMPTA_ACOMPTE_SUPPR";
export const COMPTA_ACOMPTE_VISU = "COMPTA_ACOMPTE_VISU";
export const COMPTA_CATEGORIE_DEPENSE_MODIF = "COMPTA_CATEGORIE_DEPENSE_MODIF";
export const COMPTA_CA_PREVISIONNEL_INVAL_DEF =
  "COMPTA_CA_PREVISIONNEL_INVAL_DEF";
export const COMPTA_CA_PREVISIONNEL_INVAL_INT =
  "COMPTA_CA_PREVISIONNEL_INVAL_INT";
export const COMPTA_CA_PREVISIONNEL_MODIF = "COMPTA_CA_PREVISIONNEL_MODIF";
export const COMPTA_CA_PREVISIONNEL_MODIF_VAL =
  "COMPTA_CA_PREVISIONNEL_MODIF_VAL";
export const COMPTA_CA_PREVISIONNEL_NBCOUVERTS_PLANNING_VISU =
  "COMPTA_CA_PREVISIONNEL_NBCOUVERTS_PLANNING_VISU";
export const COMPTA_CA_PREVISIONNEL_SUPPR = "COMPTA_CA_PREVISIONNEL_SUPPR";
export const COMPTA_CA_PREVISIONNEL_SUPPR_VAL =
  "COMPTA_CA_PREVISIONNEL_SUPPR_VAL";
export const COMPTA_CA_PREVISIONNEL_VAL_DEF = "COMPTA_CA_PREVISIONNEL_VAL_DEF";
export const COMPTA_CA_PREVISIONNEL_VAL_INT = "COMPTA_CA_PREVISIONNEL_VAL_INT";
export const COMPTA_CA_PREVISIONNEL_VISU = "COMPTA_CA_PREVISIONNEL_VISU";
export const COMPTA_CLIENT_SITE_ACTIVATE = "COMPTA_CLIENT_SITE_ACTIVATE";
export const COMPTA_CLIENT_SITE_CHANGE_COMPTE =
  "COMPTA_CLIENT_SITE_CHANGE_COMPTE";
export const COMPTA_CLIENT_SITE_CREATE = "COMPTA_CLIENT_SITE_CREATE";
export const COMPTA_CLIENT_SITE_DELETE = "COMPTA_CLIENT_SITE_DELETE";
export const COMPTA_CLIENT_SITE_MODIF = "COMPTA_CLIENT_SITE_MODIF";
export const COMPTA_CLIENT_SITE_VISU = "COMPTA_CLIENT_SITE_VISU";
export const COMPTA_COMPTE_MODIF = "COMPTA_COMPTE_MODIF";
export const COMPTA_COMPTE_SUPPR = "COMPTA_COMPTE_SUPPR";
export const COMPTA_COMPTE_VISU = "COMPTA_COMPTE_VISU";
export const COMPTA_DEPENSE_MODIF = "COMPTA_DEPENSE_MODIF";
export const COMPTA_DEPENSE_SUPPR = "COMPTA_DEPENSE_SUPPR";
export const COMPTA_DEPENSE_VISU = "COMPTA_DEPENSE_VISU";
export const COMPTA_EMPLOYE_PRIME_MODIF = "COMPTA_EMPLOYE_PRIME_MODIF";
export const COMPTA_EMPLOYE_PRIME_VISU = "COMPTA_EMPLOYE_PRIME_VISU";
export const COMPTA_EXERCICE_ADD = "COMPTA_EXERCICE_ADD";
export const COMPTA_EXERCICE_CLOSE = "COMPTA_EXERCICE_CLOSE";
export const COMPTA_EXERCICE_MODIF = "COMPTA_EXERCICE_MODIF";
export const COMPTA_EXERCICE_VISU = "COMPTA_EXERCICE_VISU";
export const COMPTA_FOURNISSEUR_MODIF = "COMPTA_FOURNISSEUR_MODIF";
export const COMPTA_IMPORT = "COMPTA_IMPORT";
export const COMPTA_JOURNAL_VISU = "COMPTA_JOURNAL_VISU";
export const COMPTA_OPERATION_MODIF = "COMPTA_OPERATION_MODIF";
export const COMPTA_OPERATION_SUPPR = "COMPTA_OPERATION_SUPPR";
export const COMPTA_OPERATION_VISU = "COMPTA_OPERATION_VISU";
export const COMPTA_PREFERENCES = "COMPTA_PREFERENCES";
export const COMPTA_PRIME_TYPE_MODIF = "COMPTA_PRIME_TYPE_MODIF";
export const COMPTA_SAISIE_SALAIRE_MODIF = "COMPTA_SAISIE_SALAIRE_MODIF";
export const COMPTA_SAISIE_SALAIRE_VISU = "COMPTA_SAISIE_SALAIRE_VISU";
export const COMPTA_TAUX_TVA_MODIF = "COMPTA_TAUX_TVA_MODIF";
export const CTRL_SITE_MODELE_ACCESS_LEVEL_1 =
  "CTRL_SITE_MODELE_ACCESS_LEVEL_1";
export const CTRL_SITE_MODELE_ACCESS_LEVEL_2 =
  "CTRL_SITE_MODELE_ACCESS_LEVEL_2";
export const CTRL_SITE_MODELE_MODIF = "CTRL_SITE_MODELE_MODIF";
export const CTRL_SITE_MODIF = "CTRL_SITE_MODIF";
export const CTRL_SITE_NOTIFY_NEW_AUDIT_BY_MAIL =
  "CTRL_SITE_NOTIFY_NEW_AUDIT_BY_MAIL";
export const CTRL_SITE_TRANSFERT = "CTRL_SITE_TRANSFERT";
export const CTRL_SITE_VISU = "CTRL_SITE_VISU";
export const DASHBOARD_MODIF = "DASHBOARD_MODIF";
export const EDI_DEFAULT_THIRD_PARTY_SOFT_WRITE =
  "EDI_DEFAULT_THIRD_PARTY_SOFT_WRITE";
export const ELECTRONICSIGNATURE_YOUSIGN_CANCEL =
  "ELECTRONICSIGNATURE_YOUSIGN_CANCEL";
export const ELECTRONICSIGNATURE_YOUSIGN_SEND =
  "ELECTRONICSIGNATURE_YOUSIGN_SEND";
export const ELECTRONICSIGNATURE_YOUSIGN_ACHIEVEDSCHEDULE_CANCEL =
  "ELECTRONICSIGNATURE_YOUSIGN_ACHIEVEDSCHEDULE_CANCEL";
export const ELECTRONICSIGNATURE_YOUSIGN_ACHIEVEDSCHEDULE_SEND =
  "ELECTRONICSIGNATURE_YOUSIGN_ACHIEVEDSCHEDULE_SEND";
export const ENERGIE_INVAL_DEF = "ENERGIE_INVAL_DEF";
export const ENERGIE_INVAL_INT = "ENERGIE_INVAL_INT";
export const ENERGIE_MODIF = "ENERGIE_MODIF";
export const ENERGIE_PREFERENCES = "ENERGIE_PREFERENCES";
export const ENERGIE_SUPPR = "ENERGIE_SUPPR";
export const ENERGIE_VAL_DEF = "ENERGIE_VAL_DEF";
export const ENERGIE_VAL_INT = "ENERGIE_VAL_INT";
export const ENERGIE_VISU = "ENERGIE_VISU";
export const FDC_CREER = "FDC_CREER";
export const FDC_CUMULEE_VISU = "FDC_CUMULEE_VISU";
export const FDC_IMPORT_CA_FROM_CAISSES = "FDC_IMPORT_CA_FROM_CAISSES";
export const FDC_IMPORT_ENCAISSEMENTS_FROM_CAISSES =
  "FDC_IMPORT_ENCAISSEMENTS_FROM_CAISSES";
export const FDC_IMPORT_STATISTIQUES_FROM_CAISSES =
  "FDC_IMPORT_STATISTIQUES_FROM_CAISSES";
export const FDC_INVALDEF = "FDC_INVALDEF";
export const FDC_INVALINT = "FDC_INVALINT";
export const FDC_MODIF = "FDC_MODIF";
export const FDC_MODIFINT = "FDC_MODIFINT";
export const FDC_REPARTITION_SERVICE_VISU = "FDC_REPARTITION_SERVICE_VISU";
export const FDC_SUPPR = "FDC_SUPPR";
export const FDC_TABANNUL = "FDC_TABANNUL";
export const FDC_TABEVOLUTIONCASITE = "FDC_TABEVOLUTIONCASITE";
export const FDC_TABFINANCIER = "FDC_TABFINANCIER";
export const FDC_TABOBJ = "FDC_TABOBJ";
export const FDC_TABPAIEMENT = "FDC_TABPAIEMENT";
export const FDC_TABREPARTITIONCA = "FDC_TABREPARTITIONCA";
export const FDC_TABSTAT = "FDC_TABSTAT";
export const FDC_TABSTATCOMP = "FDC_TABSTATCOMP";
export const FDC_TABSUIVICOUVERTS = "FDC_TABSUIVICOUVERTS";
export const FDC_TABTVA = "FDC_TABTVA";
export const FDC_TRANSFERER = "FDC_TRANSFERER";
export const FDC_UPDATE_CASH_DEFER = "FDC_UPDATE_CASH_DEFER";
export const FDC_VALDEF = "FDC_VALDEF";
export const FDC_VALINT = "FDC_VALINT";
export const FDC_VISU = "FDC_VISU";
export const FDC_VISU_ARCHIVE_2ANS = "FDC_VISU_ARCHIVE_2ANS";
export const FILEEXCHANGE_EXPORT = "FILEEXCHANGE_EXPORT";
export const FILEEXCHANGE_FORMAT_USE = "FILEEXCHANGE_FORMAT_USE";
export const FILEEXCHANGE_FORMAT_WRITE = "FILEEXCHANGE_FORMAT_WRITE";
export const FILEEXCHANGE_IMPORT = "FILEEXCHANGE_IMPORT";
export const FRANCE_FRAIS_THIRD_PARTY_SOFT_WRITE =
  "FRANCE_FRAIS_THIRD_PARTY_SOFT_WRITE";
export const GES_ACHATS_IMPORT = "GES_ACHATS_IMPORT";
export const GES_ALLERGENE_MODIF = "GES_ALLERGENE_MODIF";
export const GES_AVOIR_DELETE = "GES_AVOIR_DELETE";
export const GES_AVOIR_MODIF = "GES_AVOIR_MODIF";
export const GES_AVOIR_VISU = "GES_AVOIR_VISU";
export const GES_BDC_DELETE = "GES_BDC_DELETE";
export const GES_BDC_ENVOI = "GES_BDC_ENVOI";
export const GES_BDC_EXPORT = "GES_BDC_EXPORT";
export const GES_BDC_FAVORITE_MODIF = "GES_BDC_FAVORITE_MODIF";
export const GES_BDC_MODIF = "GES_BDC_MODIF";
export const GES_BDC_MODIFIER_PRIX = "GES_BDC_MODIFIER_PRIX";
export const GES_BDC_VALIDER_PRD = "GES_BDC_VALIDER_PRD";
export const GES_BDC_VISU = "GES_BDC_VISU";
export const GES_BDL_INVAL_DEF = "GES_BDL_INVAL_DEF";
export const GES_BDL_INVAL_INT = "GES_BDL_INVAL_INT";
export const GES_BDL_LIGNE_MOTIF_MODIF = "GES_BDL_LIGNE_MOTIF_MODIF";
export const GES_BDL_MODIF = "GES_BDL_MODIF";
export const GES_BDL_MODIFIER_PRIX = "GES_BDL_MODIFIER_PRIX";
export const GES_BDL_MODIF_DATE = "GES_BDL_MODIF_DATE";
export const GES_BDL_MODIF_INT = "GES_BDL_MODIF_INT";
export const GES_BDL_VAL_DEF = "GES_BDL_VAL_DEF";
export const GES_BDL_VAL_INT = "GES_BDL_VAL_INT";
export const GES_BDL_VISU = "GES_BDL_VISU";
export const GES_CADENCIER = "GES_CADENCIER";
export const GES_CARTE_MODIF = "GES_CARTE_MODIF";
export const GES_CARTE_SECTION_MODIF = "GES_CARTE_SECTION_MODIF";
export const GES_CARTE_VISU = "GES_CARTE_VISU";
export const GES_CATALOGUE_MODIF = "GES_CATALOGUE_MODIF";
export const GES_CATALOGUE_VISU = "GES_CATALOGUE_VISU";
export const GES_COMPARE_PRIX = "GES_COMPARE_PRIX";
export const GES_ETAPE_MODIF = "GES_ETAPE_MODIF";
export const GES_FICHETECHNIQUE_GROUPE_MODIF =
  "GES_FICHETECHNIQUE_GROUPE_MODIF";
export const GES_FICHETECHNIQUE_MODIF = "GES_FICHETECHNIQUE_MODIF";
export const GES_FICHETECHNIQUE_CREATE = "GES_FICHETECHNIQUE_CREATE";
export const GES_FICHETECHNIQUE_VISU = "GES_FICHETECHNIQUE_VISU";
export const GES_FOURNISSEUR_MODIF = "GES_FOURNISSEUR_MODIF";
export const GES_FOURNISSEUR_VISU = "GES_FOURNISSEUR_VISU";
export const GES_FOURNISSEUR_VOIR_PRIX_CACHES =
  "GES_FOURNISSEUR_VOIR_PRIX_CACHES";
export const GES_GESTION_IMPORT = "GES_GESTION_IMPORT";
export const GES_INVENTAIRE_CHANGE_DATE = "GES_INVENTAIRE_CHANGE_DATE";
export const GES_INVENTAIRE_INVAL = "GES_INVENTAIRE_INVAL";
export const GES_INVENTAIRE_INVAL_DEF = "GES_INVENTAIRE_INVAL_DEF";
export const GES_INVENTAIRE_MODIF = "GES_INVENTAIRE_MODIF";
export const GES_INVENTAIRE_MODIF_VAL = "GES_INVENTAIRE_MODIF_VAL";
export const GES_INVENTAIRE_SUPP = "GES_INVENTAIRE_SUPP";
export const GES_INVENTAIRE_SUPP_VAL = "GES_INVENTAIRE_SUPP_VAL";
export const GES_INVENTAIRE_VAL = "GES_INVENTAIRE_VAL";
export const GES_INVENTAIRE_VAL_DEF = "GES_INVENTAIRE_VAL_DEF";
export const GES_INVENTAIRE_VISU = "GES_INVENTAIRE_VISU";
export const GES_LIEUXSTOCKAGE_MODIF = "GES_LIEUXSTOCKAGE_MODIF";
export const GES_MAJORS_MODIF = "GES_MAJORS_MODIF";
export const GES_MODIF_TARIF_MOTIF_MODIF = "GES_MODIF_TARIF_MOTIF_MODIF";
export const GES_MOUVEMENT_STOCK_DEST_SITES = "GES_MOUVEMENT_STOCK_DEST_SITES";
export const GES_MOUVEMENT_STOCK_ETAT_MODIF = "GES_MOUVEMENT_STOCK_ETAT_MODIF";
export const GES_MOUVEMENT_STOCK_LOCKED_MODIF =
  "GES_MOUVEMENT_STOCK_LOCKED_MODIF";
export const GES_MOUVEMENT_STOCK_MODIF = "GES_MOUVEMENT_STOCK_MODIF";
export const GES_MOUVEMENT_STOCK_MOTIF_MODIF =
  "GES_MOUVEMENT_STOCK_MOTIF_MODIF";
export const GES_MOUVEMENT_STOCK_VISU = "GES_MOUVEMENT_STOCK_VISU";
export const GES_PERTES_VISU = "GES_PERTES_VISU";
export const GES_PERTE_MODIF = "GES_PERTE_MODIF";
export const GES_PERTE_MOTIF_MODIF = "GES_PERTE_MOTIF_MODIF";
export const GES_PERTE_SUPP = "GES_PERTE_SUPP";
export const GES_POSTES_MODIF = "GES_POSTES_MODIF";
export const GES_PRDFOU_DELETE = "GES_PRDFOU_DELETE";
export const GES_PRDFOU_MODIF = "GES_PRDFOU_MODIF";
export const GES_PRDFOU_VISU = "GES_PRDFOU_VISU";
export const GES_PRDORDER_VISU = "GES_PRDORDER_VISU";
export const GES_PRD_DELETE = "GES_PRD_DELETE";
export const GES_PRD_MODIF = "GES_PRD_MODIF";
export const GES_PRD_STOCK_MODIF = "GES_PRD_STOCK_MODIF";
export const GES_PRD_VISU = "GES_PRD_VISU";
export const GES_PREFERENCES = "GES_PREFERENCES";
export const GES_RECAP_ECARTS_LIV = "GES_RECAP_ECARTS_LIV";
export const GES_RECAP_MONTANTS = "GES_RECAP_MONTANTS";
export const GES_RUBRIQUESFOU_MODIF = "GES_RUBRIQUESFOU_MODIF";
export const GES_RUBRIQUESFT_MODIF = "GES_RUBRIQUESFT_MODIF";
export const GES_RUBRIQUES_MODIF = "GES_RUBRIQUES_MODIF";
export const GES_TAB_CUMUL_MENSUEL_PERTE_VISU =
  "GES_TAB_CUMUL_MENSUEL_PERTE_VISU";
export const GES_TAB_CUMUL_PERTE_VISU = "GES_TAB_CUMUL_PERTE_VISU";
export const GES_TAB_ECARTS_VISU = "GES_TAB_ECARTS_VISU";
export const GES_TAB_STOCK_THEORIQUE_VISU = "GES_TAB_STOCK_THEORIQUE_VISU";
export const GES_TAB_SUIVI_MARGE_VISU = "GES_TAB_SUIVI_MARGE_VISU";
export const GES_TAB_SUIVI_RENT_VISU = "GES_TAB_SUIVI_RENT_VISU";
export const GES_TYPE_INVENTAIRE_MODIF = "GES_TYPE_INVENTAIRE_MODIF";
export const GES_UNITES_MODIF = "GES_UNITES_MODIF";
export const GES_VALOCINQ_MODIF = "GES_VALOCINQ_MODIF";
export const GES_VALOCINQ_VISU = "GES_VALOCINQ_VISU";
export const GES_VALOSTD_MODIF = "GES_VALOSTD_MODIF";
export const GES_VENTES_IMPORT = "GES_VENTES_IMPORT";
export const GES_VENTES_MAPPING_FT_MODIF = "GES_VENTES_MAPPING_FT_MODIF";
export const GES_VENTES_STATS_VISU = "GES_VENTES_STATS_VISU";
export const GES_VENTES_VISU = "GES_VENTES_VISU";
export const GES_VENTE_CHANGE_DATES = "GES_VENTE_CHANGE_DATES";
export const GES_VENTE_INVAL = "GES_VENTE_INVAL";
export const GES_VENTE_INVAL_DEF = "GES_VENTE_INVAL_DEF";
export const GES_VENTE_MODIF = "GES_VENTE_MODIF";
export const GES_VENTE_MODIF_VAL = "GES_VENTE_MODIF_VAL";
export const GES_VENTE_SUPP = "GES_VENTE_SUPP";
export const GES_VENTE_SUPP_VAL = "GES_VENTE_SUPP_VAL";
export const GES_VENTE_VAL = "GES_VENTE_VAL";
export const GES_VENTE_VAL_DEF = "GES_VENTE_VAL_DEF";
export const GES_VOLUMES_FRS = "GES_VOLUMES_FRS";
export const HACCP_CONTROLE_INSPECTION = "HACCP_CONTROLE_INSPECTION";
export const HACCP_COOKING_METHOD_MODIF = "HACCP_COOKING_METHOD_MODIF";
export const HACCP_COOKING_MODIF = "HACCP_COOKING_MODIF";
export const HACCP_COOKING_VISU = "HACCP_COOKING_VISU";
export const HACCP_EMPLOYE_MODIF = "HACCP_EMPLOYE_MODIF";
export const HACCP_EQUIPEMENT_CHAUD_MODIF = "HACCP_EQUIPEMENT_CHAUD_MODIF";
export const HACCP_EQUIPEMENT_FROID_MODIF = "HACCP_EQUIPEMENT_FROID_MODIF";
export const HACCP_ETALONNAGE_MODIF = "HACCP_ETALONNAGE_MODIF";
export const HACCP_ETALONNAGE_VISU = "HACCP_ETALONNAGE_VISU";
export const HACCP_ETIQUETTE_VISU = "HACCP_ETIQUETTE_VISU";
export const HACCP_FICHETECHNIQUE_MODIF = "HACCP_FICHETECHNIQUE_MODIF";
export const HACCP_FOURNISSEUR_MODIF = "HACCP_FOURNISSEUR_MODIF";
export const HACCP_FREEZING_METHOD_MODIF = "HACCP_FREEZING_METHOD_MODIF";
export const HACCP_FREEZING_MODIF = "HACCP_FREEZING_MODIF";
export const HACCP_FREEZING_VISU = "HACCP_FREEZING_VISU";
export const HACCP_FRITEUSE_MODIF = "HACCP_FRITEUSE_MODIF";
export const HACCP_HUILE_DE_FRITURE_MODIF = "HACCP_HUILE_DE_FRITURE_MODIF";
export const HACCP_HUILE_DE_FRITURE_VISU = "HACCP_HUILE_DE_FRITURE_VISU";
export const HACCP_IMPORT = "HACCP_IMPORT";
export const HACCP_LIVRAISON_MODIF = "HACCP_LIVRAISON_MODIF";
export const HACCP_LIVRAISON_MOTIF_REFUS_MODIF =
  "HACCP_LIVRAISON_MOTIF_REFUS_MODIF";
export const HACCP_LIVRAISON_VISU = "HACCP_LIVRAISON_VISU";
export const HACCP_LOT_INTERNE_MODIF = "HACCP_LOT_INTERNE_MODIF";
export const HACCP_LOT_INTERNE_VISU = "HACCP_LOT_INTERNE_VISU";
export const HACCP_MATERIEL_MOBILE_VISU = "HACCP_MATERIEL_MOBILE_VISU";
export const HACCP_MATERIEL_MODIF = "HACCP_MATERIEL_MODIF";
export const HACCP_METHODE_ETALONNAGE_MODIF = "HACCP_METHODE_ETALONNAGE_MODIF";
export const HACCP_PND_ENTRY_CONTROL = "HACCP_PND_ENTRY_CONTROL";
export const HACCP_PND_ENTRY_SIGN = "HACCP_PND_ENTRY_SIGN";
export const HACCP_PND_PLANNING_MODIF = "HACCP_PND_PLANNING_MODIF";
export const HACCP_PND_PLANNING_VISU = "HACCP_PND_PLANNING_VISU";
export const HACCP_PND_POSTE_MODIF = "HACCP_PND_POSTE_MODIF";
export const HACCP_PND_TASK_MODIF = "HACCP_PND_TASK_MODIF";
export const HACCP_PRD_FAMILLE_MODIF = "HACCP_PRD_FAMILLE_MODIF";
export const HACCP_PREFERENCES = "HACCP_PREFERENCES";
export const HACCP_PROCESS_TEMPLATE_MODIF = "HACCP_PROCESS_TEMPLATE_MODIF";
export const HACCP_PRODUIT_MODIF = "HACCP_PRODUIT_MODIF";
export const HACCP_RELEVE_TEMPERATURE_SONDES_DISRUPTIVE =
  "HACCP_RELEVE_TEMPERATURE_SONDES_DISRUPTIVE";
export const HACCP_RELEVE_TEMP_ANOMALIE_ACTION_MODIF =
  "HACCP_RELEVE_TEMP_ANOMALIE_ACTION_MODIF";
export const HACCP_RELEVE_TEMP_ANOMALIE_ACTION_VISU =
  "HACCP_RELEVE_TEMP_ANOMALIE_ACTION_VISU";
export const HACCP_RELEVE_TEMP_ANOMALIE_CAUSE_MODIF =
  "HACCP_RELEVE_TEMP_ANOMALIE_CAUSE_MODIF";
export const HACCP_RELEVE_TEMP_ANOMALIE_CAUSE_VISU =
  "HACCP_RELEVE_TEMP_ANOMALIE_CAUSE_VISU";
export const HACCP_RELEVE_TEMP_ANOMALIE_MODIF =
  "HACCP_RELEVE_TEMP_ANOMALIE_MODIF";
export const HACCP_RELEVE_TEMP_ANOMALIE_TYPE_ACTION_MODIF =
  "HACCP_RELEVE_TEMP_ANOMALIE_TYPE_ACTION_MODIF";
export const HACCP_RELEVE_TEMP_ANOMALIE_TYPE_CAUSE_MODIF =
  "HACCP_RELEVE_TEMP_ANOMALIE_TYPE_CAUSE_MODIF";
export const HACCP_RELEVE_TEMP_ANOMALIE_VISU =
  "HACCP_RELEVE_TEMP_ANOMALIE_VISU";
export const HACCP_RELEVE_TEMP_MODIF = "HACCP_RELEVE_TEMP_MODIF";
export const HACCP_RELEVE_TEMP_VISU = "HACCP_RELEVE_TEMP_VISU";
export const HACCP_REMISE_EN_TEMP_CHAUD_MODIF =
  "HACCP_REMISE_EN_TEMP_CHAUD_MODIF";
export const HACCP_REMISE_EN_TEMP_CHAUD_VISU =
  "HACCP_REMISE_EN_TEMP_CHAUD_VISU";
export const HACCP_REMISE_EN_TEMP_COOLING_MODIF =
  "HACCP_REMISE_EN_TEMP_COOLING_MODIF";
export const HACCP_REMISE_EN_TEMP_COOLING_TYPE_MODIF =
  "HACCP_REMISE_EN_TEMP_COOLING_TYPE_MODIF";
export const HACCP_REMISE_EN_TEMP_COOLING_VISU =
  "HACCP_REMISE_EN_TEMP_COOLING_VISU";
export const HACCP_REMISE_EN_TEMP_CRU_MODIF = "HACCP_REMISE_EN_TEMP_CRU_MODIF";
export const HACCP_REMISE_EN_TEMP_CRU_VISU = "HACCP_REMISE_EN_TEMP_CRU_VISU";
export const HACCP_REMISE_EN_TEMP_EQUIPEMENT_TEST_MODIF =
  "HACCP_REMISE_EN_TEMP_EQUIPEMENT_TEST_MODIF";
export const HACCP_REMISE_EN_TEMP_EQUIPEMENT_TEST_VISU =
  "HACCP_REMISE_EN_TEMP_EQUIPEMENT_TEST_VISU";
export const HACCP_REMISE_EN_TEMP_MODIF = "HACCP_REMISE_EN_TEMP_MODIF";
export const HACCP_REMISE_EN_TEMP_VISU = "HACCP_REMISE_EN_TEMP_VISU";
export const HACCP_SOUSVIDE_MODIF = "HACCP_SOUSVIDE_MODIF";
export const HACCP_SOUSVIDE_VISU = "HACCP_SOUSVIDE_VISU";
export const HACCP_TAG_GESTION_FICHE_PRD_ET_FT =
  "HACCP_TAG_GESTION_FICHE_PRD_ET_FT";
export const HACCP_TAG_MODIF = "HACCP_TAG_MODIF";
export const HACCP_TRACABILITECLASSEMENT_MODIF =
  "HACCP_TRACABILITECLASSEMENT_MODIF";
export const HACCP_TRACABILITE_MODIF = "HACCP_TRACABILITE_MODIF";
export const HACCP_TRACABILITE_VISU = "HACCP_TRACABILITE_VISU";
export const HACCP_TRACAPRODUCTION_MODIF = "HACCP_TRACAPRODUCTION_MODIF";
export const HACCP_TRACAPRODUCTION_VISU = "HACCP_TRACAPRODUCTION_VISU";
export const HACCP_UNITE_MODIF = "HACCP_UNITE_MODIF";
export const INTRANET_SHARED_FILES_ACCESS_LEVEL_1 =
  "INTRANET_SHARED_FILES_ACCESS_LEVEL_1";
export const INTRANET_SHARED_FILES_ACCESS_LEVEL_2 =
  "INTRANET_SHARED_FILES_ACCESS_LEVEL_2";
export const INTRANET_SHARED_FILES_ACCESS_LEVEL_3 =
  "INTRANET_SHARED_FILES_ACCESS_LEVEL_3";
export const INTRANET_SHARED_FILES_ACCESS_LEVEL_4 =
  "INTRANET_SHARED_FILES_ACCESS_LEVEL_4";
export const INTRANET_SHARED_FILES_ACCESS_LEVEL_5 =
  "INTRANET_SHARED_FILES_ACCESS_LEVEL_5";
export const INTRANET_SHARED_FILES_CREATE_FOLDER =
  "INTRANET_SHARED_FILES_CREATE_FOLDER";
export const INTRANET_SHARED_FILES_DELETE = "INTRANET_SHARED_FILES_DELETE";
export const INTRANET_SHARED_FILES_MOVE = "INTRANET_SHARED_FILES_MOVE";
export const INTRANET_SHARED_FILES_RENAME = "INTRANET_SHARED_FILES_RENAME";
export const INTRANET_SHARED_FILES_UPDATE_DETAILS =
  "INTRANET_SHARED_FILES_UPDATE_DETAILS";
export const INTRANET_SHARED_FILES_UPLOAD = "INTRANET_SHARED_FILES_UPLOAD";
export const INTRANET_SHARED_FILES_VISU = "INTRANET_SHARED_FILES_VISU";
export const MANUEL_UTILISATEUR_VISU = "MANUEL_UTILISATEUR_VISU";
export const MES_SITES = "MES_SITES";
export const MSG_MODIF = "MSG_MODIF";
export const MSG_VISU = "MSG_VISU";
export const MYCAWAN_STAFF_ABSENCES_DISMISSAL =
  "MYCAWAN_STAFF_ABSENCES_DISMISSAL";
export const MYCAWAN_STAFF_ABSENCES_IMPOSITION =
  "MYCAWAN_STAFF_ABSENCES_IMPOSITION";
export const MYCAWAN_STAFF_ABSENCES_VALIDATION =
  "MYCAWAN_STAFF_ABSENCES_VALIDATION";
export const MYCAWAN_STAFF_DOCUMENTS_VALIDATION =
  "MYCAWAN_STAFF_DOCUMENTS_VALIDATION";
export const MYCAWAN_STAFF_INVITE = "MYCAWAN_STAFF_INVITE";
export const MYCAWAN_STAFF_REVOKE = "MYCAWAN_STAFF_REVOKE";
export const PREVOGEL_THIRD_PARTY_SOFT_WRITE =
  "PREVOGEL_THIRD_PARTY_SOFT_WRITE";
export const RH_AFFECTATION_ATTACHMENT_ADD = "RH_AFFECTATION_ATTACHMENT_ADD";
export const RH_AFFECTATION_ATTACHMENT_DELETE =
  "RH_AFFECTATION_ATTACHMENT_DELETE";
export const RH_AFFECTATION_ATTACHMENT_VISU = "RH_AFFECTATION_ATTACHMENT_VISU";
export const RH_AFFECTATION_CHANGE_CODE_PAIE =
  "RH_AFFECTATION_CHANGE_CODE_PAIE";
export const RH_AFFECTATION_CREER = "RH_AFFECTATION_CREER";
export const RH_AFFECTATION_DUPLICATE = "RH_AFFECTATION_DUPLICATE";
export const RH_AFFECTATION_FERM = "RH_AFFECTATION_FERM";
export const RH_AFFECTATION_HANDLE_VISIBILITY =
  "RH_AFFECTATION_HANDLE_VISIBILITY";
export const RH_AFFECTATION_MODIF = "RH_AFFECTATION_MODIF";
export const RH_AFFECTATION_RECALCUL_COMPTEURS =
  "RH_AFFECTATION_RECALCUL_COMPTEURS";
export const RH_AFFECTATION_REPARTITION_VISU =
  "RH_AFFECTATION_REPARTITION_VISU";
export const RH_AFFECTATION_SALAIRES_VISU = "RH_AFFECTATION_SALAIRES_VISU";
export const RH_AFFECTATION_SUPP = "RH_AFFECTATION_SUPP";
export const RH_AFFECTATION_VISU = "RH_AFFECTATION_VISU";
export const RH_ANALYSE_CODES_ADMIN = "RH_ANALYSE_CODES_ADMIN";
export const RH_ANALYSE_PLANNINGS = "RH_ANALYSE_PLANNINGS";
export const RH_ARRET_TRAVAIL_ADD_ATTACHMENT =
  "RH_ARRET_TRAVAIL_ADD_ATTACHMENT";
export const RH_ARRET_TRAVAIL_CREER = "RH_ARRET_TRAVAIL_CREER";
export const RH_ARRET_TRAVAIL_DELETE_ATTACHMENT =
  "RH_ARRET_TRAVAIL_DELETE_ATTACHMENT";
export const RH_ARRET_TRAVAIL_MODIF = "RH_ARRET_TRAVAIL_MODIF";
export const RH_ARRET_TRAVAIL_SUPPR = "RH_ARRET_TRAVAIL_SUPPR";
export const RH_ARRET_TRAVAIL_VISU = "RH_ARRET_TRAVAIL_VISU";
export const RH_BILAN_COMPETENCE_MODIF = "RH_BILAN_COMPETENCE_MODIF";
export const RH_BILAN_COMPETENCE_VISU = "RH_BILAN_COMPETENCE_VISU";
export const RH_COMPETENCE_MODIF = "RH_COMPETENCE_MODIF";
export const RH_CP_IMPORT_CP_ACQUIS = "RH_CP_IMPORT_CP_ACQUIS";
export const RH_CP_IMPORT_FICHES_HORAIRES = "RH_CP_IMPORT_FICHES_HORAIRES";
export const RH_CP_IMPORT_SAGE = "RH_CP_IMPORT_SAGE";
export const RH_CP_INVAL_DEFINITIF = "RH_CP_INVAL_DEFINITIF";
export const RH_CP_INVAL_PROVISOIRE = "RH_CP_INVAL_PROVISOIRE";
export const RH_CP_MODIF = "RH_CP_MODIF";
export const RH_CP_VAL_DEFINITIF = "RH_CP_VAL_DEFINITIF";
export const RH_CP_VAL_PROVISOIRE = "RH_CP_VAL_PROVISOIRE";
export const RH_CP_VISU = "RH_CP_VISU";
export const RH_CYCLE_SOLDE_MANAGE = "RH_CYCLE_SOLDE_MANAGE";
export const RH_CYCLE_SYNTHESE_VISU = "RH_CYCLE_SYNTHESE_VISU";
export const RH_DISPONIBILITES_MODIF = "RH_DISPONIBILITES_MODIF";
export const RH_DISPONIBILITES_VISU = "RH_DISPONIBILITES_VISU";
export const RH_DIVERS_ARCHIVES_UN_AN = "RH_DIVERS_ARCHIVES_UN_AN";
export const RH_DOCUMENTS_ACCESS_LEVEL_1 = "RH_DOCUMENTS_ACCESS_LEVEL_1";
export const RH_DOCUMENTS_ACCESS_LEVEL_2 = "RH_DOCUMENTS_ACCESS_LEVEL_2";
export const RH_DOCUMENTS_ACCESS_LEVEL_3 = "RH_DOCUMENTS_ACCESS_LEVEL_3";
export const RH_DOCUMENTS_ACCESS_LEVEL_4 = "RH_DOCUMENTS_ACCESS_LEVEL_4";
export const RH_DOCUMENTS_ACCESS_LEVEL_5 = "RH_DOCUMENTS_ACCESS_LEVEL_5";
export const RH_DOCUMENTS_MODIF = "RH_DOCUMENTS_MODIF";
export const RH_DOCUMENTS_VISU = "RH_DOCUMENTS_VISU";
export const RH_DPP_ACCESS_LEVEL_1 = "RH_DPP_ACCESS_LEVEL_1";
export const RH_DPP_ACCESS_LEVEL_2 = "RH_DPP_ACCESS_LEVEL_2";
export const RH_DPP_CREER = "RH_DPP_CREER";
export const RH_DPP_EXPORT = "RH_DPP_EXPORT";
export const RH_DPP_EXPORT_PAIE = "RH_DPP_EXPORT_PAIE";
export const RH_DPP_GERER_MODELES = "RH_DPP_GERER_MODELES";
export const RH_DPP_INVALID_DEFINITIF = "RH_DPP_INVALID_DEFINITIF";
export const RH_DPP_INVALID_PROVISOIRE = "RH_DPP_INVALID_PROVISOIRE";
export const RH_DPP_MODIF = "RH_DPP_MODIF";
export const RH_DPP_MODIF_VALID_PROVISOIRE = "RH_DPP_MODIF_VALID_PROVISOIRE";
export const RH_DPP_PRINT_SYNTHESE = "RH_DPP_PRINT_SYNTHESE";
export const RH_DPP_SUPPR = "RH_DPP_SUPPR";
export const RH_DPP_VALID_DEFINITIF = "RH_DPP_VALID_DEFINITIF";
export const RH_DPP_VALID_PROVISOIRE = "RH_DPP_VALID_PROVISOIRE";
export const RH_DPP_VISU = "RH_DPP_VISU";
export const RH_EMPLOYE_CREER = "RH_EMPLOYE_CREER";
export const RH_EMPLOYE_REGISTRE_VISU = "RH_EMPLOYE_REGISTRE_VISU";
export const RH_EMPLOYE_SUPP = "RH_EMPLOYE_SUPP";
export const RH_EMPLOYE_VISU_OTHER_SITES = "RH_EMPLOYE_VISU_OTHER_SITES";
export const RH_ETAT_CIVIL_FILES_ADD = "RH_ETAT_CIVIL_FILES_ADD";
export const RH_ETAT_CIVIL_FILES_SUPP = "RH_ETAT_CIVIL_FILES_SUPP";
export const RH_ETAT_CIVIL_FILES_VISU = "RH_ETAT_CIVIL_FILES_VISU";
export const RH_ETAT_CIVIL_MODIF = "RH_ETAT_CIVIL_MODIF";
export const RH_ETAT_CIVIL_VISU = "RH_ETAT_CIVIL_VISU";
export const RH_FDS_CONSOLIDEE = "RH_FDS_CONSOLIDEE";
export const RH_FDS_CONTROLE = "RH_FDS_CONTROLE";
export const RH_FDS_CUMUL = "RH_FDS_CUMUL";
export const RH_FDS_INVAL_DEFINITIF = "RH_FDS_INVAL_DEFINITIF";
export const RH_FDS_INVAL_PROVISOIRE = "RH_FDS_INVAL_PROVISOIRE";
export const RH_FDS_MODIF = "RH_FDS_MODIF";
export const RH_FDS_MODIF_VAL_PROVISOIRE = "RH_FDS_MODIF_VAL_PROVISOIRE";
export const RH_FDS_MONTANTS_FDC_VISU = "RH_FDS_MONTANTS_FDC_VISU";
export const RH_FDS_VAL_DEFINITIF = "RH_FDS_VAL_DEFINITIF";
export const RH_FDS_VAL_PROVISOIRE = "RH_FDS_VAL_PROVISOIRE";
export const RH_FDS_VISU = "RH_FDS_VISU";
export const RH_FICHE_HORAIRE_ALERTE = "RH_FICHE_HORAIRE_ALERTE";
export const RH_FICHE_HORAIRE_PRINT_SIGN_JOUR =
  "RH_FICHE_HORAIRE_PRINT_SIGN_JOUR";
export const RH_FICHE_HORAIRE_PRINT_SIGN_SEMAINE =
  "RH_FICHE_HORAIRE_PRINT_SIGN_SEMAINE";
export const RH_FILE_CATEGORY_MODIF = "RH_FILE_CATEGORY_MODIF";
export const RH_FONCTION_MODIF = "RH_FONCTION_MODIF";
export const RH_FORMATION_ADD_ATTACHMENT = "RH_FORMATION_ADD_ATTACHMENT";
export const RH_FORMATION_CREER = "RH_FORMATION_CREER";
export const RH_FORMATION_DELETE_ATTACHMENT = "RH_FORMATION_DELETE_ATTACHMENT";
export const RH_FORMATION_MODIF = "RH_FORMATION_MODIF";
export const RH_FORMATION_SUPPR = "RH_FORMATION_SUPPR";
export const RH_FORMATION_VISU = "RH_FORMATION_VISU";
export const RH_GRILLES_SALAIRE = "RH_GRILLES_SALAIRE";
export const RH_JOURS_FERIES_ANNEE_PRECEDENTE_VISU =
  "RH_JOURS_FERIES_ANNEE_PRECEDENTE_VISU";
export const RH_JOURS_FERIES_MODIF = "RH_JOURS_FERIES_MODIF";
export const RH_JOURS_FERIES_VISU = "RH_JOURS_FERIES_VISU";
export const RH_MANDATORY_FIELD_MODIF = "RH_MANDATORY_FIELD_MODIF";
export const RH_CUSTOM_FIELD_MODIF = "RH_CUSTOM_FIELD_MODIF";
export const RH_MOTIF_ARRIVEE_TARDIVE_MODIF = "RH_MOTIF_ARRIVEE_TARDIVE_MODIF";
export const RH_NATURE_SANCTION_MODIF = "RH_NATURE_SANCTION_MODIF";
export const RH_NIVEAU_COMPETENCE_MODIF = "RH_NIVEAU_COMPETENCE_MODIF";
export const RH_PLANNING_ALERTE = "RH_PLANNING_ALERTE";
export const RH_PLANNING_BROUILLON_VISU = "RH_PLANNING_BROUILLON_VISU";
export const RH_PLANNING_ENVOI_EMAIL = "RH_PLANNING_ENVOI_EMAIL";
export const RH_PLANNING_EQUIVALENCE_HORAIRE_MODIF =
  "RH_PLANNING_EQUIVALENCE_HORAIRE_MODIF";
export const RH_PLANNING_FICHE_HORAIRE_CONSOLIDATION_VISU =
  "RH_PLANNING_FICHE_HORAIRE_CONSOLIDATION_VISU";
export const RH_PLANNING_FICHE_HORAIRE_HEBDO_VISU =
  "RH_PLANNING_FICHE_HORAIRE_HEBDO_VISU";
export const RH_PLANNING_FICHE_HORAIRE_MENSUELLE_VISU =
  "RH_PLANNING_FICHE_HORAIRE_MENSUELLE_VISU";
export const RH_PLANNING_FICHE_HORAIRE_VISU = "RH_PLANNING_FICHE_HORAIRE_VISU";
export const RH_PLANNING_INVAL_DEFINITIF = "RH_PLANNING_INVAL_DEFINITIF";
export const RH_PLANNING_INVAL_PROVISOIRE = "RH_PLANNING_INVAL_PROVISOIRE";
export const RH_PLANNING_PREVISIONNEL_MODIF = "RH_PLANNING_PREVISIONNEL_MODIF";
export const RH_PLANNING_PRINT = "RH_PLANNING_PRINT";
export const RH_PLANNING_PUBLIER = "RH_PLANNING_PUBLIER";
export const RH_PLANNING_REEL_MODIF = "RH_PLANNING_REEL_MODIF";
export const RH_PLANNING_REEL_MODIF_VAL_PROVISOIRE =
  "RH_PLANNING_REEL_MODIF_VAL_PROVISOIRE";
export const RH_PLANNING_TAG_DOMAIN_MODIF = "RH_PLANNING_TAG_DOMAIN_MODIF";
export const RH_PLANNING_TAG_SITE_MODIF = "RH_PLANNING_TAG_SITE_MODIF";
export const RH_PLANNING_TEMPLATE_DOMAIN_MODIF =
  "RH_PLANNING_TEMPLATE_DOMAIN_MODIF";
export const RH_PLANNING_TEMPLATE_SITE_MODIF =
  "RH_PLANNING_TEMPLATE_SITE_MODIF";
export const RH_PLANNING_TEMPS_PAUSE_MODIF = "RH_PLANNING_TEMPS_PAUSE_MODIF";
export const RH_PLANNING_VAL_DEFINITIF = "RH_PLANNING_VAL_DEFINITIF";
export const RH_PLANNING_VAL_PROVISOIRE = "RH_PLANNING_VAL_PROVISOIRE";
export const RH_PLANNING_VISU = "RH_PLANNING_VISU";
export const RH_POINTAGE_IMPORT_IN_PLANNING_REEL =
  "RH_POINTAGE_IMPORT_IN_PLANNING_REEL";
export const RH_POINTAGE_MATERIEL_MOBILE_VISU =
  "RH_POINTAGE_MATERIEL_MOBILE_VISU";
export const RH_POINTAGE_MODIF = "RH_POINTAGE_MODIF";
export const RH_POINTAGE_VISU = "RH_POINTAGE_VISU";
export const RH_POSTE_MODIF = "RH_POSTE_MODIF";
export const RH_PREFERENCES = "RH_PREFERENCES";
export const RH_PROFIL_COMPETENCE_MODIF = "RH_PROFIL_COMPETENCE_MODIF";
export const RH_RCR_SOLDE_MANAGE = "RH_RCR_SOLDE_MANAGE";
export const RH_RCR_SYNTHESE_VISU = "RH_RCR_SYNTHESE_VISU";
export const RH_RECAP_TRANSPORT = "RH_RECAP_TRANSPORT";
export const RH_REMUN_EXTRA_VISU = "RH_REMUN_EXTRA_VISU";
export const RH_SANCTION_ADD_ATTACHMENT = "RH_SANCTION_ADD_ATTACHMENT";
export const RH_SANCTION_CREER = "RH_SANCTION_CREER";
export const RH_SANCTION_DELETE_ATTACHMENT = "RH_SANCTION_DELETE_ATTACHMENT";
export const RH_SANCTION_MODIF = "RH_SANCTION_MODIF";
export const RH_SANCTION_SUPPR = "RH_SANCTION_SUPPR";
export const RH_SANCTION_VISU = "RH_SANCTION_VISU";
export const RH_SECTION_MODIF = "RH_SECTION_MODIF";
export const RH_SMIC_MODIF = "RH_SMIC_MODIF";
export const RH_TEMPS_PREFERENCES = "RH_TEMPS_PREFERENCES";
export const RH_THEME_FORMATION_MODIF = "RH_THEME_FORMATION_MODIF";
export const RH_TRANSFERT = "RH_TRANSFERT";
export const RH_TRANSPORT_MODIF = "RH_TRANSPORT_MODIF";
export const RH_TYPE_ARRET_TRAVAIL_MODIF = "RH_TYPE_ARRET_TRAVAIL_MODIF";
export const RH_TYPE_SANCTION_MODIF = "RH_TYPE_SANCTION_MODIF";
export const RH_TYPE_VISITE_MEDICALE_MODIF = "RH_TYPE_VISITE_MEDICALE_MODIF";
export const RH_VISITE_MEDICALE_ADD_ATTACHMENT =
  "RH_VISITE_MEDICALE_ADD_ATTACHMENT";
export const RH_VISITE_MEDICALE_CREER = "RH_VISITE_MEDICALE_CREER";
export const RH_VISITE_MEDICALE_DELETE_ATTACHMENT =
  "RH_VISITE_MEDICALE_DELETE_ATTACHMENT";
export const RH_VISITE_MEDICALE_MODIF = "RH_VISITE_MEDICALE_MODIF";
export const RH_VISITE_MEDICALE_SUPPR = "RH_VISITE_MEDICALE_SUPPR";
export const RH_VISITE_MEDICALE_VISU = "RH_VISITE_MEDICALE_VISU";
export const SAGE_THIRD_PARTY_SOFT_WRITE = "SAGE_THIRD_PARTY_SOFT_WRITE";
export const SILAE_THIRD_PARTY_SOFT_WRITE = "SILAE_THIRD_PARTY_SOFT_WRITE";
export const SITE_JOURS_IMPORTANTS_MODIF = "SITE_JOURS_IMPORTANTS_MODIF";
export const SITE_JOURS_IMPORTANTS_VISU = "SITE_JOURS_IMPORTANTS_VISU";
export const STEF_THIRD_PARTY_SOFT_WRITE = "STEF_THIRD_PARTY_SOFT_WRITE";
export const SYNTHESE_TABPROD_CAHEURE_VISU = "SYNTHESE_TABPROD_CAHEURE_VISU";
export const SYNTHESE_TABPROD_COMPAR_PROD_VISU =
  "SYNTHESE_TABPROD_COMPAR_PROD_VISU";
export const SYNTHESE_TABPROD_MASSESALARIALE_VISU =
  "SYNTHESE_TABPROD_MASSESALARIALE_VISU";
export const SYNTHESE_TABPROD_MINCLIENT_VISU =
  "SYNTHESE_TABPROD_MINCLIENT_VISU";
export const SYNTHESE_TABPROD_PRESENCECLIENT_VISU =
  "SYNTHESE_TABPROD_PRESENCECLIENT_VISU";
export const SYNTHESE_TABPROD_STATPRESENCE_VISU =
  "SYNTHESE_TABPROD_STATPRESENCE_VISU";
export const SYNTHESE_TABPROD_SUIVI_PLANNING_HEBDO_VISU =
  "SYNTHESE_TABPROD_SUIVI_PLANNING_HEBDO_VISU";
export const SYNTHESE_TABPROD_SUIVI_PLANNING_VISU =
  "SYNTHESE_TABPROD_SUIVI_PLANNING_VISU";
export const SYNTHESE_TABPROD_SYNTHESE_HEBDO_VISU =
  "SYNTHESE_TABPROD_SYNTHESE_HEBDO_VISU";
export const TDB_GLOBAL_VISU = "TDB_GLOBAL_VISU";
export const VIF_THIRD_PARTY_SOFT_WRITE = "VIF_THIRD_PARTY_SOFT_WRITE";
